import { aw as h } from './p-a57042e3.js';
const MultiChildrenWrapper = (_props, children) => h("div", {
  style: {
    display: 'contents'
  }
}, children);
export { MultiChildrenWrapper as M };